var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 23,
    viewBox: "0 0 25.6 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4241",
    "data-name": "Group 4241",
    transform: "translate(-50 -196.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M147,40.5a.5.5,0,1,1-.5-.5A.5.5,0,0,1,147,40.5Zm0,0",
    transform: "translate(-88.699 158.375)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M107,40.5a.5.5,0,1,1-.5-.5A.5.5,0,0,1,107,40.5Zm0,0",
    transform: "translate(-50.699 158.375)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M67,40.5a.5.5,0,1,1-.5-.5A.5.5,0,0,1,67,40.5Zm0,0",
    transform: "translate(-12.699 158.375)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M84.5,140h-18a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h18a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,84.5,140Zm-.5,3H67v-2H84Zm0,0",
    transform: "translate(-12.699 63.375)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M75.5,260h-9a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,.5-.5v-6A.5.5,0,0,0,75.5,260Zm-.5,6H67v-5h8Zm0,0",
    transform: "translate(-12.699 -50.625)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M312.5,260h-6a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h6a.5.5,0,0,0,.5-.5v-6A.5.5,0,0,0,312.5,260Zm-.5,6h-5v-5h5Zm0,0",
    transform: "translate(-240.699 -50.625)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M247,.5a.5.5,0,1,1-.5-.5A.5.5,0,0,1,247,.5Zm0,0",
    transform: "translate(-183.699 196.375)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M24.1,0H15.05a.5.5,0,1,0,0,1H24.1a.5.5,0,0,1,.5.5V4H1V1.5A.5.5,0,0,1,1.5,1h9.05a.5.5,0,0,0,0-1H1.5A1.5,1.5,0,0,0,0,1.5v20A1.5,1.5,0,0,0,1.5,23H24.1a1.5,1.5,0,0,0,1.5-1.5V1.5A1.5,1.5,0,0,0,24.1,0Zm0,22H1.5a.5.5,0,0,1-.5-.5V5H24.6V21.5A.5.5,0,0,1,24.1,22Zm0,0",
    transform: "translate(50 196.375)",
    fill: "#6a707e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.01bcf0bb81d653d28010c0de012f4081.svg";
export { ForwardRef as ReactComponent };